import { render, staticRenderFns } from "./password-expired.vue?vue&type=template&id=476f1f3e&scoped=true&"
import script from "./password-expired.vue?vue&type=script&lang=js&"
export * from "./password-expired.vue?vue&type=script&lang=js&"
import style0 from "./password-expired.vue?vue&type=style&index=0&id=476f1f3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476f1f3e",
  null
  
)

export default component.exports